import { type ComponentType, createContext } from "react";

export type TrailEntry = {
  readonly path: string;
  readonly search?: string;
  readonly hash?: string;
  readonly label: string;
  readonly icon?: ComponentType;
};

export type BreadcrumbTrailContextValue = {
  readonly trail: readonly TrailEntry[];
  readonly resetTrail: (path: string, search: string, hash: string, label: string, icon?: ComponentType) => void;
  readonly updateEntry: (path: string, search: string, hash: string, label: string, icon?: ComponentType) => void;
};

export const BreadcrumbTrailContext = createContext<BreadcrumbTrailContextValue | null>(null);
